import styled from "styled-components";
import { keyframes } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: ${props => props.height};
  height: 100%;
  background-color: #121d2e;
`;

export const Logo = styled.img`
  margin-bottom: 10px;
`;

export const Loader = styled.div`
  position: relative;
  margin-top: 10px;
  width: 55px;
  height: 55px;
`;

const SpinAnimation = keyframes`
  0%  {-webkit-transform: rotate(0deg);}
  100% {-webkit-transform: rotate(360deg);} 
`;

export const Spinner = styled.div`
  position: absolute;
  width: 50px;
  height: 54px;
  border-radius: 50%;
  border: 3px solid #385799;
  -webkit-animation: ${SpinAnimation} 0.75s infinite linear;
`;

export const Spinner2 = styled.div`
  position: absolute;
  width: 54px;
  height: 50px;
  border-radius: 50%;
  border: 3px solid #ef742c;
  -webkit-animation: ${SpinAnimation} 0.75s infinite linear;
`;
